<section class="top_nav">
    <div class="nav-content">
      <div class="dashboard-details">
        <div class="dashboard-logo">
          <img class="me-2" [src]="appConfigService.config.branding.logos.primary"   alt="logo"
            [routerLink]="['/home']">
        </div>
      </div>
      <div class="user_profile">
        <button mat-button [matMenuTriggerFor]="beforeMenuProfile">
          <div class="profile-details">
            <div class="profile-avatar">{{ userInitials }}</div>
            <div class="admin_name">{{ userName }}</div>
            <i class="ri-arrow-down-s-line"></i>
          </div>
        </button>
        <mat-menu #beforeMenuProfile="matMenu" xPosition="before" class="profile-dropdown-menu" panelClass="profile-dropdown-menu">
          <!-- <a class="change_pass" href="#" mat-menu-item [routerLink]="['account/change-password']">
            <i class="ri-lock-line"></i>
            <span>Change Password</span>
          </a> -->
          <button class="log_out" (click)="logOut()" mat-menu-item>
            <i class="ri-logout-circle-r-line"></i>
            <span>Logout</span>
          </button>
        </mat-menu>
      </div>
    </div>
  
  </section>